import { getSubmissionSteps } from '~/components/traffic-tickets/steps/steps'

const TRACKING_STEP_NAMES = {}

// create an object with the correct Google Analytics label names for each step
// ex: violation --> 1.violation
getSubmissionSteps(true).forEach((step) => {
  const stepSlug = step.slug
  TRACKING_STEP_NAMES[stepSlug] = `${step.order+1}.${stepSlug}`
  // we add +1 as the step 0 is the state selector which is not in Submission steps
})

export default TRACKING_STEP_NAMES
